AFRAME.registerComponent('predefined-rotation-controls', {
    schema: {
        target: { type: 'selector' },
        cameraRig: { type: 'selector', default: '#cameraRig' }
    },

    init: function () {
        const el = this.el;
        const component = this;
        const cameraRig = this.data.cameraRig || document.querySelector('#cameraRig');

        const getCurrentTarget = () => {
            let target = component.data.target;
            
            if (target && target.isConnected && document.body.contains(target)) {
                return target;
            }
            
            if (target && target.id) {
                target = document.getElementById(target.id);
                if (target && target.isConnected) {
                    return target;
                }
            }
            
            target = document.querySelector('#stock-3d-cube-wrapper');
            if (target && target.isConnected) {
                return target;
            }
            
            target = document.querySelector('#news-graph-wrapper');
            if (target && target.isConnected) {
                return target;
            }
            
            const allWrappers = document.querySelectorAll('[id$="-wrapper"]');
            for (let wrapper of allWrappers) {
                if (wrapper.isConnected && wrapper.id.includes('stock-3d-cube')) {
                    return wrapper;
                }
            }
            
            return null;
        };

        if (!cameraRig) {
            console.warn("[predefined-rotation-controls] No camera rig found. Billboard updates may not work.");
        } else {
            console.log("[predefined-rotation-controls] Camera rig found:", cameraRig);
        }

        const buttons = [
            { id: 'side-1', image: "/vr-assets/rotation-icons/side-1.png", position: "0 0 0", rotation: "30 -10 -30" },
            { id: 'side-2', image: "/vr-assets/rotation-icons/side-2.png", position: "0.15 0 0", rotation: "0 136 60" },
            { id: 'side-3', image: "/vr-assets/rotation-icons/side-3.png", position: "-0.15 0 0", rotation: "90 45 0" },
        ];

        buttons.forEach(({ id, label, image, position, rotation }) => {
            const btn = document.createElement("a-entity");
            btn.setAttribute("id", id);
            btn.setAttribute("ui-button", {
                label: label || "",
                image: image || '',
                width: 0.12,
                height: 0.12,
                depth: 0.02,
                type: "rounded-box",
                colorScheme: "primary",
                radius: 0.015,
                contentRotation: -45,
                // isAutoRotationContent: true
            });
            btn.setAttribute("position", position);

            btn.addEventListener("click", () => {
                const target = getCurrentTarget();
                
                if (!target) {
                    console.warn(`[predefined-rotation-controls ${id}] Button clicked, but no target available.`);
                    return;
                }

                console.log(btn, btn.rotation);
                target.setAttribute("rotation", `${rotation}`);
                const rotationValues = { x: parseFloat(rotation.split(' ')[0]), y: parseFloat(rotation.split(' ')[1]), z: parseFloat(rotation.split(' ')[2]) };
                target.emit('update-rotation', rotationValues);
                component.el.sceneEl.emit('update-rotation', rotationValues);

                if (cameraRig) {
                    cameraRig.emit('update-billboards');
                }

                if (window.gtag) gtag('event', `VR_CenterPanel_ChartRotation`);
            });

            el.appendChild(btn);
        });

    },

    update: function (oldData) {
        if (oldData.target !== this.data.target) {
            console.log("[predefined-rotation-controls] Target updated:", this.data.target);
        }
    }
});
